import { ReactComponent as ArrowDownLightIcon } from './arrowDownLight.svg';

export default ArrowDownLightIcon;
